import AppBar from "../../components/AppBar";
import SearchBar from "../../components/SearchBar";
import dropwDownArrow from "../../assets/svg/dropdown-arrow.svg";
import calendarIcon from "../../assets/svg/calender-icon.svg";
import menuIcons from "../../assets/png/menu-icon.png";
import phoneIcon from "../../assets/png/phone.png";
import mailIcon from "../../assets/png/mail.png";
import Pagination from "../../components/Pagination";
import gateLogo from "../../assets/png/gate-logo.png";
import deleteIcon from "../../assets/svg/delete-icon.svg";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import addIcon from "../../assets/svg/add-icon.svg";
import MyDateRangePicker from "../../components/Calendar";
import "react-calendar/dist/Calendar.css";
import { apiRequest } from "../../services/api_services/ApiServices";
import ConfirmDialog from "../../components/ConfirmDialog";
import viewIcon from "../../assets/svg/view-icon.svg";
import syncIcon from "../../assets/svg/sync-icon.svg";
import CircularLoader from "../../components/CicularLoader";
import { toast } from "react-toastify";
import { format } from "date-fns";

const AdminSettingPage = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Users");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const ref = useRef(null);
  const { state } = useLocation();
  const [botList, setBots] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteBot, setDeleteBot] = useState({
    id: null,
    name: "",
  });

  const [loadingId, setLoadingId] = useState(null);

  const [botHeader, SetBotHead] = useState([]);
  const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [chatBotPagination, setChatBotPagination] = useState({
    perPage: 10,
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
  });
  const [userPagination, setUserPagination] = useState({
    perPage: 10,
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
  });

  const hasFetchedRef = useRef(false);
  const toYMD = (date) => date.toISOString().split("T")[0];

  useEffect(() => {
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchUser(1, userPagination.perPage, search);
    fetchBot(1, chatBotPagination.perPage, search);
  }, [search]);

  useEffect(() => {
    setSelectedTab(state?.selectedTab === "Chatbots" ? "Chatbot" : "Users");
    console.log(state?.selectedTab);
  }, [state?.selectedTab]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDeleteClick = (bot) => {
    setDeleteBot({
      id: bot.app_id,
      name: bot.bot_name,
    });

    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    await botQuestionsDelete();
    setOpenDialog(false);
  };

  const botQuestionsDelete = async () => {
    try {
      const response = await apiRequest({
        method: "delete",
        url: "bot_delete",
        data: {
          bot_name: deleteBot.name,
          app_id: deleteBot.id,
        },
      });

      if (response.statusCode == 400) {
      } else {
        if (response?.success) {
          fetchBot();

          toast.success(response?.message);
        } else {
          toast.error(response?.message || "Failed to fetch applications");
        }
      }
    } catch (error) {
      toast.error("Application list error:", error);
    }
  };
  const fetchUser = async (
    pageNo = userPagination.currentPage,
    limit = userPagination.perPage,
    searchValue = "",
  ) => {
    try {
      const response = await apiRequest({
        method: "get",
        url: "user_list",
        params: {
          page: pageNo,
          per_page: limit,
          search: searchValue || "",
         
        },
      });

      if (response.statusCode == 400) {
      } else {
        const apiData = response?.data;
        console.log(apiData);

        setUserList(apiData?.data ?? []);

        setUserPagination({
          perPage: Number(apiData?.per_page) || limit,
          currentPage: Number(apiData?.current_page) || pageNo,
          totalPages: Number(apiData?.total_pages) || 0,
          totalRecords: Number(apiData?.total_records) || 0,
        });
      }
    } catch (error) {
      toast.error("Application list error:", error);
    }
  };

  const syncBot = async (appId) => {
    setLoadingId(appId.app_id);

    try {
      const response = await apiRequest({
        method: "post",
        url: "presync",
        data: {
          app_id: String(appId.app_id),
        },
      });
      if (response.statusCode == 400) {
        setLoadingId(null);
      } else {
        setLoadingId(null);

        toast.success(response.message || "");
      }
    } catch (e) {
      setLoadingId(null);
      toast.success("Failed to Sync" || "");
    }
  };

  const fetchBot = async (
    pageNo = chatBotPagination.currentPage,
    limit = chatBotPagination.perPage,
    searchValue = search,
  ) => {
    try {
      const response = await apiRequest({
        method: "GET",
        url: "bot",
        params: {
          page: pageNo,
          per_page: limit,
          search: searchValue || "",
        
        },
      });

      if (response.statusCode == 400) {
        setLoadingId(null);
      } else {
        setLoadingId(null);
        const apiData = response?.data;
        console.log(apiData);

        setBots(apiData?.data ?? []);

        setChatBotPagination({
          perPage: Number(apiData?.per_page) || limit,
          currentPage: Number(apiData?.current_page) || pageNo,
          totalPages: Number(apiData?.total_pages) || 0,
          totalRecords: Number(apiData?.total_records) || 0,
        });
      }
    } catch (error) {
      setLoadingId(null);
      console.error(error);
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <AppBar onClick={() => navigate("/")} title="Settings" />
      <div className="flex-1 bg-[#F8F9FB] p-4">
        <div className="w-full bg-white p-3 rounded-2xl">
          <div className="flex items-center justify-center gap-2">
            <div
              className={` px-3 py-3
    rounded-full
    flex items-center justify-center
    cursor-pointer whitespace-nowrap
    border border-gray-300
    text-[#535E83]       
          ${
            selectedTab === "Users"
              ? "bg-gradient-to-t from-[#007DFE] to-[#00ABEF] text-white"
              : "bg-white border border-gray-300 text-[#535E83] font-bold"
          }`}
              onClick={() => setSelectedTab("Users")}
            >
              <span className="text-[14px] font-semibold leading-none font-omny">
                Users {userPagination.totalRecords}
              </span>
            </div>

            <div
              className={` px-3 py-3
    rounded-full
    flex items-center justify-center
    cursor-pointer whitespace-nowrap
    border border-gray-300
    text-[#535E83]
          ${
            selectedTab === "Chatbot"
              ? "bg-gradient-to-t from-[#007DFE] to-[#00ABEF] text-white"
              : "bg-white border border-gray-300 text-[#535E83]"
          }`}
              onClick={() => {
                setSelectedTab("Chatbot");
              }}
            >
              <span className="text-[14px] font-semibold leading-none font-omny">
                Chat bots {chatBotPagination.totalRecords}
              </span>
            </div>

            <div className="ml-auto flex items-center gap-3">
              <SearchBar
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearch(value);
                  selectedTab === "Users"
                    ? fetchUser(1, userPagination.perPage, value)
                    : fetchBot(1, chatBotPagination.perPage, value);
                }}
              />

              {selectedTab === "Users" ? (
                ""
              ) : (
               
                <button
                  className="
    flex items-center gap-3
    px-2 py-1.5
    rounded-full
    bg-gradient-to-b from-[#6A6CF6] to-[#3F42E5]
    text-white text-lg font-semibold
    shadow-[0_6px_0_#2F32C9]
    hover:opacity-90
    active:translate-y-[2px]
    active:shadow-[0_4px_0_#2F32C9]
    transition-all
    mb-2
  "
                  onClick={() => navigate("/bot_creation")}
                >
                  <span className="flex items-center gap-2 p-1.5 text-base font-semibold leading-none font-euclid">
                    <img src={addIcon} alt="Add Icon" className="w-4 h-4" />
                    Add New Bot
                  </span>
                </button>
              )}
              
            </div>
          </div>
          <ConfirmDialog
            open={openDialog}
            title="Delete Bot"
            message={`Are you sure you want to delete "${deleteBot.name}"?`}
            onConfirm={confirmDelete}
            onCancel={() => setOpenDialog(false)}
          />
          <div>
            <div className="border-l-2 border-r-2 border-[#E5E5E5] bg-white mt-3 overflow-hidden ">
              <table className="w-full border-t-0 ">
                <thead className="bg-[#F8F8F8] border-b ">
                  <tr className="text-left text-xs text-[#535E83] uppercase">
                    <th className="px-8 py-3 border-r border-gray-200">
                      <div className="flex items-center justify-between text-sm font-euclid font-semibold ">
                        {selectedTab === "Users" ? "User Name" : "Bot Name"}
                        <img
                          src={menuIcons}
                          alt="menu"
                          className="h-[15px] w-[10px]"
                        />
                      </div>
                    </th>

                    <th className="px-8 py-3 border-r border-gray-200">
                      <div className="flex items-center justify-between text-sm font-euclid font-semibold">
                        {selectedTab === "Users"
                          ? " Phone Number  "
                          : "Application"}
                        <img
                          src={menuIcons}
                          alt="menu"
                          className="h-[15px] w-[10px]"
                        />
                      </div>
                    </th>

                    <th className="px-8 py-3 border-r border-gray-200">
                      <div className="flex items-center justify-between text-sm font-euclid font-semibold">
                        {selectedTab === "Users" ? "Email " : "Questions Input"}
                        <img
                          src={menuIcons}
                          alt="menu"
                          className="h-[15px] w-[10px]"
                        />
                      </div>
                    </th>

                    {selectedTab === "Users" ? (
                      <th className="px-8 py-3">
                        <div className="flex items-center justify-between text-sm font-euclid font-semibold">
                          Chat History
                          <img
                            src={menuIcons}
                            alt="menu"
                            className="h-[15px] w-[10px]"
                          />
                        </div>
                      </th>
                    ) : (
                      <></>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {selectedTab === "Users"
                    ? userList.map((user, index) => (
                        <tr
                          key={index}
                          className="border-b hover:bg-gray-200"
                          onClick={() =>
                            navigate("/user_view", {
                              state: {
                                userName: user.username,
                                userId: user.user_id,
                              },
                            })
                          }
                        >
                          <td className="px-8 py-3 border-r border-gray-100 text-[#172B4D] font-regular font-euclid text-base">
                            {user.username || "--:---"}
                          </td>

                          <td className="px-8 py-3 border-r border-gray-100 text-[#172B4D] font-regular font-euclid text-base ">
                            <div className="flex items-center gap-2 text-md ">
                              <img
                                src={phoneIcon}
                                alt="phone"
                                className="w-4 h-4"
                              />
                              <span>{user.contact_number || "--:---"}</span>
                            </div>
                          </td>

                          <td className="px-8 py-3 border-r border-gray-100 text-blue-500 font-regular font-euclid text-base">
                            <div className="flex items-center gap-2 text-md">
                              <img
                                src={mailIcon}
                                alt="mail"
                                className="w-4 h-4"
                              />
                              <span>{user.email || "--:---"}</span>
                            </div>
                          </td>

                          {selectedTab === "Users" ? (
                            <td className="px-8 py-3 text-[#172B4D] font-regular font-euclid text-base">
                              {user.conversation_count}
                            </td>
                          ) : (
                            <></>
                          )}
                        </tr>
                      ))
                    : botList.map((bot, index) => (
                        <tr
                          key={index}
                          className="border-b hover:bg-gray-200"
                          onMouseEnter={() => setHoveredRow(index)}
                          onMouseLeave={() => setHoveredRow(null)}
                        >
                          <td
                            className="px-6 py-3 border-r border-gray-100 text-[#172B4D] font-regular font-euclid text-base"
                            onClick={() =>
                              navigate("/chat_bot_edit", {
                                state: {
                                  name: bot.bot_name,
                                  application_id: bot.app_id,
                                },
                              })
                            }
                          >
                            {bot.bot_name || "--:---"}
                          </td>

                          <td className="px-6 py-3 border-r border-gray-100 text-[#172B4D] font-regular font-euclid text-base">
                            <div
                              className="flex items-center gap-2"
                              onClick={() =>
                                navigate("/chat_bot_edit", {
                                  state: {
                                    name: bot.bot_name,
                                    application_id: bot.app_id,
                                  },
                                })
                              }
                            >
                              <span>{bot.application_name || "--:---"}</span>
                            </div>
                          </td>

                          <td className="px-6 py-3 text-[#172B4D] font-regular font-euclid relative text-base">
                            <div className="flex items-center justify-between">
                              <span>{bot.question_count || "--:---"}</span>
                            </div>

                            {hoveredRow === index && (
                              <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-3">
                                <div
                                  className="w-8 h-8 flex items-center justify-center cursor-pointer rounded-full bg-white hover:bg-gray-100 transition-colors "
                                  onClick={() => {
                                    syncBot(bot);
                                  }}
                                >
                                  {loadingId === bot.app_id ? (
                                    <CircularLoader
                                      size={16}
                                      color="border-red"
                                    />
                                  ) : (
                                    <img
                                      src={syncIcon}
                                      alt="sync"
                                      className="w-4 h-4"
                                    />
                                  )}
                                </div>
                                <div
                                  className="w-8 h-8 flex items-center justify-center cursor-pointer rounded-full bg-white hover:bg-gray-100 transition-colors "
                                  onClick={() =>
                                    navigate("/chat_bot_edit", {
                                      state: {
                                        name: bot.bot_name,
                                        application_id: bot.app_id,
                                      },
                                    })
                                  }
                                >
                                  <img
                                    src={viewIcon}
                                    alt="view"
                                    className="w-5 h-5"
                                  />
                                </div>

                                <img
                                  onClick={() => handleDeleteClick(bot)}
                                  src={deleteIcon}
                                  alt="delete"
                                  className="w-8 h-8 cursor-pointer"
                                />
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
            <></>
            <Pagination
              currentPage={
                selectedTab === "Users"
                  ? userPagination.currentPage
                  : chatBotPagination.currentPage
              }
              totalPages={
                selectedTab === "Users"
                  ? userPagination.totalPages
                  : chatBotPagination.totalPages
              }
              recordsPerPage={
                selectedTab === "Users"
                  ? userPagination.perPage
                  : chatBotPagination.perPage
              }
              onPageChange={(page) => {
                selectedTab === "Users"
                  ? fetchUser(page, userPagination.perPage, search)
                  : fetchBot(page, chatBotPagination.perPage, search);
              }}
              onPageSizeChange={(size) => {
                selectedTab === "Users"
                  ? fetchUser(1, size, search)
                  : fetchBot(1, size, search);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingPage;
